import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../layouts/footer/footer.component';
import { RegistrationHeaderComponent } from '../layouts/registration-header/registration-header.component';

@Component({
    selector: 'app-welcome',
    imports: [MatButtonModule, RouterModule, RegistrationHeaderComponent, FooterComponent],
    templateUrl: './welcome.component.html',
    styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

}
